// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3NAtb","productName":"Table_productName__q7jpX"};